import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=0f343a06&lang=pug&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f343a06')) {
      api.createRecord('0f343a06', component.options)
    } else {
      api.reload('0f343a06', component.options)
    }
    module.hot.accept("./Orders.vue?vue&type=template&id=0f343a06&lang=pug&", function () {
      api.rerender('0f343a06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/orders/Orders.vue"
export default component.exports